var _path, _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundenlogoGJ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 90,
    viewBox: "0 0 180 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H172C176.142 0.5 179.5 3.85786 179.5 8V82C179.5 86.1421 176.142 89.5 172 89.5H8C3.85786 89.5 0.5 86.1421 0.5 82V8Z",
    stroke: "#F3F0E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_972_603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 179,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 88,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_972_603)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0669 38.0119H114.711H91.0669ZM102.912 26.3906V49.7476V26.3906Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0669 38.0119H114.711M102.912 26.3906V49.7476",
    stroke: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1337 45.8942C78.296 46.5972 79.5608 46.5545 79.5608 48.6305V62.0896C79.5608 64.9732 79.8375 72.2101 68.5329 72.518C52.9219 72.9441 54.3112 48.0902 54.3112 48.0902C54.3112 48.0902 54.1531 20.3219 68.6515 20.2443C81.8336 20.1863 88.3752 37.8865 88.3752 42.5536V20.4187C88.3752 20.4187 84.6202 28.2231 83.3158 28.2231C82.5451 28.2231 77.8216 20.2638 68.6515 20.2638C59.4951 20.2638 45.0225 29.4237 45.0225 48.0902C45.0225 66.8497 58.3014 72.2934 68.3748 72.518C77.6833 72.7252 79.7584 65.4651 84.4028 65.4651C88.8496 65.4651 89.2053 72.6555 89.2053 73.1048V48.6305C89.2053 48.6305 89.2053 48.6344 89.2053 48.6422C89.2053 46.5817 90.6085 46.5778 98.5336 45.8942H70.1337Z",
    fill: "#F3F0E5",
    stroke: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.056 19.0146L105.025 19.8835H105.056L112.693 20.3554H112.705H112.716C114.875 20.3742 115.728 21.1096 116.135 21.801C116.542 22.4924 116.476 23.1717 116.476 23.1717L116.472 23.1941V23.2166L116.495 63.6407C116.495 63.6407 116.462 65.8256 115.578 67.9925C115.136 69.0759 114.487 70.1427 113.542 70.9286C112.614 71.7013 111.399 72.211 109.744 72.2281C109.712 72.2283 109.678 72.2319 109.646 72.2319C109.521 72.2319 109.385 72.2164 109.255 72.2094C109.095 72.202 108.935 72.1951 108.778 72.1795C108.207 72.1147 107.603 71.9908 106.981 71.805C106.764 71.74 106.542 71.6597 106.322 71.5802C104.712 70.9193 103.399 69.8257 102.406 68.6067C101.6 67.6174 101.011 66.5483 100.666 65.5882C100.437 64.9486 100.331 64.3651 100.314 63.8916C101.008 64.4519 102.229 65.165 104.275 65.165C106.079 65.165 107.625 64.5642 108.71 63.4947C109.794 62.4252 110.404 60.8977 110.404 59.113C110.404 55.5197 107.644 53.0048 104.237 53.0048C102.472 53.0048 100.723 53.5325 99.4193 54.7912C98.1152 56.0498 97.2891 58.0188 97.2891 60.7758V61.7495L97.3649 61.6821C97.6378 65.2011 99.4145 67.9903 101.697 69.91C103.289 71.2483 105.11 72.1766 106.852 72.6738C107.123 72.7564 107.402 72.8242 107.686 72.8835C107.723 72.8912 107.759 72.8987 107.796 72.906C108.075 72.9609 108.357 73.0067 108.649 73.0371C108.891 73.0645 109.125 73.0778 109.358 73.0858C109.462 73.089 109.559 73.1045 109.665 73.1045C109.693 73.1045 109.717 73.0973 109.744 73.097C113.297 73.0839 117.416 72.3534 120.706 70.4642C124.027 68.5578 126.494 65.4116 126.494 60.7683V23.2353V23.2166V23.1979C126.494 23.1979 126.439 22.5364 126.854 21.8571C127.27 21.1779 128.133 20.4528 130.273 20.434H130.289H130.304L137.066 19.8835H137.073L137.111 19.8798L137.073 19.0146H137.039H105.082H105.056Z",
    fill: "#F3F0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.3333,
    height: 57.7778,
    fill: "white",
    transform: "translate(43.7778 16.5557)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoGJ);
export default __webpack_public_path__ + "static/media/kundenlogo-g-j.17ee9529d45dfa7fbe2b2e6b0fdf25ea.svg";
export { ForwardRef as ReactComponent };